// extracted by mini-css-extract-plugin
export default {"row":"style_row__KiLqg","mySavedList":"style_mySavedList__tVwYX","noData":"style_noData__fOXIr","col4":"style_col4__N3lFV"};